import React, { useState } from "react";
import { Box, Typography, Link, Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CategoriesModal from "../common/Modal/CategoriesModal";

function ExploreCategories() {
  const [CategoriesModalOpen, setCategoriesModalOpen] = useState(false);
  const handleCategoriesModal = () => {
    setCategoriesModalOpen(!CategoriesModalOpen);
  };
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        height: "232px",
        padding: "24px 16px",
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontSize: "16px", fontWeight: "600", lineHeight: "24px" }}
      >
        Explore Machinery By
      </Typography>
      <Box
        sx={{
          marginTop: "16px",
          display: "flex",
          flexFlow: "column",
          rowGap: "16px",
        }}
      >
        <ExploreLinks
          toggle={handleCategoriesModal}
          text="Categories"
          href="#"
        />
        <ExploreLinks text="Pro" href="#" />
        <ExploreLinks text="Buy" href="#" />
        <ExploreLinks text="Auction" href="#" />
      </Box>
      <CategoriesModal
        open={CategoriesModalOpen}
        toggleDrawer={handleCategoriesModal}
      />
    </Box>
  );
}

function ExploreLinks({ text, href, toggle }) {
  return (
    <Link href={href} underline="none" onClick={toggle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            color: "#255CCE",
            lineHeight: "24px",
            fontWeight: "600",
          }}
        >
          {text}
        </Typography>
        <KeyboardArrowRightIcon
          color="#255CCE"
          sx={{ width: "24px", height: "24px" }}
        />
      </Box>
    </Link>
  );
}

export default ExploreCategories;
